require('./OKBarValueArray.scss');

const PropTypes = require('prop-types');

/**
 * This component plot a set of horizontal bars with each bar title by its side.
 * The component takes the 100% of its parent's width, and the height of its
 * content.
 *
 * You can pass three arrays:
 *
 * * names
 * * values
 * * colors
 *
 * And a boolean "highlightFirst" to set if the first value has to be
 * highlighted.
 */

// @vendors
const React = require('react');
const {
    Component
} = require('react');
const classNames = require('classnames');

class OKBarValueArray extends Component {

    getPercentage(value, totalValue) {
        return (Number(value) / Number(totalValue)) * 100;
    }

    getWidth(width = 0, offset = 0, backgroundColor = '#FFFFFF') {
        if (width === 0) {
            return ({
                display: 'none'
            });
        }

        return {
            width: `${width}%`,
            left: `${offset}%`,
            backgroundColor
        };
    }

    render() {
        const { highlightFirst, names, values, colors } = this.props;

        const maxValue = Math.max(...values);

        return (
            <div className="ok-bar-value-array">
                {
                    values.map((value, index) => {

                        let percentage = this.getPercentage(value, maxValue);

                        const barNameClass = classNames('ok-bar-value-array__name', {
                            'ok-bar-value-array__name--highlight': highlightFirst && index === 0
                        });

                        return (
                            <div key={index} className="ok-bar-value-array__container">
                                <div className="ok-bar-value-array__bar-container">
                                    <div className="ok-bar-value-array__bar"
                                        style={this.getWidth(percentage, 0, colors[index])}>
                                    </div>
                                </div>
                                <div className={barNameClass}>{ names[index] }</div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

OKBarValueArray.propTypes = {
    highlightFirst: PropTypes.bool,
    names: PropTypes.array.isRequired,
    values: PropTypes.array.isRequired,
    colors: PropTypes.array.isRequired
};

module.exports = OKBarValueArray;